<ion-app>
  <app-header class="ion-hide-lg-down"></app-header>
  <ion-router-outlet></ion-router-outlet>
  <app-footer class="ion-hide-lg-down"></app-footer>
</ion-app>
<ngx-spinner type="ball-spin"></ngx-spinner>
